import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgZoomOut = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#000",
		fillRule: "nonzero",
		d: "M19.428 10.597a8.831 8.831 0 1 0-17.662 0 8.831 8.831 0 0 0 17.662 0m-.74 6.843L28 26.75 26.751 28l-9.311-9.311a10.56 10.56 0 0 1-6.843 2.505C4.745 21.194 0 16.449 0 10.597S4.745 0 10.597 0s10.597 4.745 10.597 10.597c0 2.608-.942 4.997-2.505 6.843m-2.793-7.726v1.766H5.298V9.714z"
	})
});
export default SvgZoomOut;
